import pricingConfig from '@/config/pricing.config.json'
import providerConfig from '@/config/provider.config'
import { sendToTelegram } from './telegramService'

// Simulation des providers (à implémenter réellement ensuite)
import { processFedapay } from './payment/providers/fedapay'
import { processStripe } from './payment/providers/stripe'
import { processPaypal } from './payment/providers/paypal'

const providers = {
  fedapay: processFedapay,
  stripe: processStripe,
  paypal: processPaypal
}

/**
 * Orchestrateur de paiement
 * @param {string} productId - ID du produit (clé dans pricing.config.json)
 * @param {string} zone - Zone de prix (xof, eur, cad)
 * @param {object} customerInfo - Infos client { name, email, phone, ... }
 * @param {string} [selectedProvider] - Nom du prestataire choisi par l'utilisateur
 * @returns {Promise<{success: boolean, transactionId?: string, error?: string}>}
 */
export async function processPayment(productId, zone, customerInfo, selectedProvider = null) {
  const product = pricingConfig.products[productId]
  if (!product) {
    return { success: false, error: `Produit inconnu: ${productId}` }
  }

  const zoneConfig = pricingConfig.zones[zone]
  const amount = product.prices[zone]
  const currency = zoneConfig.currency

  console.log(`💳 Processing payment for ${productId} (${amount} ${currency})`)

  // 1. Sélection du provider (choix explicite ou premier par défaut)
  const availableProviders = product.providers[zone] || []
  const providerName = selectedProvider || availableProviders[0]
  
  console.log("🚀 ~ Selected provider:", providerName)

  // 2. Cas Gratuit
  if (providerName === 'none') {
    const success = await sendToTelegram('🎁 NOUVELLE INSCRIPTION (GRATUIT)', {
      ...customerInfo,
      certification: product.label,
      price: 'GRATUIT',
      // source: 'PaymentOrchestrator'
    })
    return { success, transactionId: 'FREE-' + Date.now() }
  }

  // 3. Cas Devis
  if (providerName === 'quote') {
    const success = await sendToTelegram('📋 DEMANDE DE DEVIS', {
      ...customerInfo,
      certification: product.label,
      price: 'Sur devis',
      // source: 'PaymentOrchestrator'
    })
    return { success, transactionId: 'QUOTE-' + Date.now() }
  }

  // 4. Cas Paiement Réel
  const providerFn = providers[providerName]
  if (!providerFn) {
    return { success: false, error: `Provider non supporté: ${providerName}` }
  }

  try {
    const result = await providerFn({
      productId,
      amount,
      currency,
      description: product.label,
      customer: customerInfo,
      config: providerConfig.providers[providerName]
    })

    if (result.success) {
      // Notification Telegram après succès du paiement
      await sendToTelegram('💰 NOUVEAU PAIEMENT RÉUSSI', {
        ...customerInfo,
        certification: product.label,
        price: `${amount} ${currency}`,
        transactionId: result.transactionId,
        paymentStatus: `✅ PAYÉ via ${providerName.toUpperCase()}`,
        // source: 'PaymentOrchestrator'
      })
    }

    return result
  } catch (error) {
    console.error(`❌ Payment error (${product.provider}):`, error)
    return { success: false, error: error.message }
  }
}

export default {
  processPayment
}
